import ResolutionReportsAPI from '../../api/resolutionReports';
import { downloadCsvFile } from '../../helper/downloadHelper';

export const state = {
  records: [],
  meta: {
    totalCount: 0,
    currentPage: 1,
  },
  uiFlags: {
    isFetching: false,
  },
};

export const getters = {
  getRecords(_state) {
    return _state.records;
  },
  getMeta(_state) {
    return _state.meta;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  get: async ({ commit }, params) => {
    commit('SET_FETCHING', true);
    try {
      const { data } = await ResolutionReportsAPI.get(params);
      commit('SET_RECORDS', data.data || []);
      commit('SET_META', data.meta || {});
    } catch {
      // handle error silently
    } finally {
      commit('SET_FETCHING', false);
    }
  },

  download: async (_store, params) => {
    try {
      const { data } = await ResolutionReportsAPI.download(params);
      downloadCsvFile('resolutions.csv', data);
    } catch {
      // handle error silently
    }
  },
};

export const mutations = {
  SET_FETCHING(_state, value) {
    _state.uiFlags.isFetching = value;
  },
  SET_RECORDS(_state, records) {
    _state.records = records;
  },
  SET_META(_state, meta) {
    _state.meta = {
      totalCount: meta.total_count || 0,
      currentPage: Number(meta.current_page) || 1,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
